<mat-accordion class="sd-nav">
  <mat-expansion-panel
    *ngFor="let route of routes$ | async"
    #matPanel
    [routerLinkActive]="['mat-expansion-panel-selected']"
    [expanded]="route | navItemActive : (currentPath$ | async)"
    [disabled]="!route.children"
  >
    <!-- expansion -->
    <mat-expansion-panel-header *ngIf="route.children">
      {{ route.title }}
    </mat-expansion-panel-header>

    <!-- direct link | no expansion -->
    <mat-expansion-panel-header *ngIf="!route.children">
      <!--
        <sd-nav-link [navItem]="route">
         </sd-nav-link>
      -->

      <!-- local -->
      <a *ngIf="!route.isExternal" [routerLink]="route.path"> {{ route.title }} </a>
      <!-- external -->
      <a *ngIf="route.isExternal" [href]="route.path"> {{ route.title }} </a>
    </mat-expansion-panel-header>

    <!-- child routes -->
    <ul *ngIf="route.children">
      <li
        *ngFor="let childRoute of route.children"
        [routerLinkActive]="['mat-expansion-panel-li-selected']"
      >
        <!--
          <sd-nav-link [navItem]="childRoute">
             </sd-nav-link>
        -->

        <!-- local -->
        <a *ngIf="!childRoute.isExternal && !childRoute.disabled" [routerLink]="childRoute.path" (click)="sendClickEvent(childRoute.title)">
          {{ childRoute.title }}
        </a>
        <!-- external -->
        <a *ngIf="childRoute.isExternal && !childRoute.disabled" [href]="childRoute.path">
          {{ childRoute.title }}
        </a>
        <!-- disabled -->
        <span class="disabled-link" *ngIf="childRoute.disabled"> {{ childRoute.title }} </span>
      </li>
    </ul>
  </mat-expansion-panel>
</mat-accordion>
